<template>
  <bg-optional-link :disabled="!link ? true : false" :to="link">
    <div :class="`BgNavigation__button`">
      <BgIcon :name="icon" :class="`BgNavigation__icon`" />
    </div>
  </bg-optional-link>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import BgOptionalLink from "@/components/bg-optional-link";
export default {
  name: "bg-navigation",
  components: {
    BgIcon,
    BgOptionalLink,
  },
  props: {
    link: {
      type: String,
      default: "",
    },
    icon: String,
  },
};
</script>
